<div
[ngClass]="{ 'hidden': current === 0 }"
*ngIf="showControls"
class="carousel__prev arrow-left"
(click)="prev()"
[ngStyle]="rigrhtArrowColorStyle"
></div>
<section class="carousel-wrapper" [ngStyle]="carouselWrapperStyle">  
  <ul class="carousel-inner" #carousel>
    <li
      *ngFor="let item of items"
      class="carousel-item"
      [ngStyle]="carouselLiStyle"
    >
      <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
    </li>
  </ul>
</section>
<ng-container *ngIf="showControls">
  <div
    *ngIf="currentSlide !== 0"
    class="carousel__prev arrow-right"
    (click)="prev()"
    [ngStyle]="rigrhtArrowColorStyle"
  ></div>
  <div
    *ngIf="currentSlide >= 0 && currentSlide !== items.length - 1"
    class="carousel__next arrow-left"
    (click)="next()"
    [ngStyle]="lefttArrowColorStyle"
  ></div>
</ng-container>
